import React from 'react';
import PropTypes from 'prop-types';
import MitraLogo from '../../../assets/mitra-logo.png';
import '../../../styles/components/MyJobsList/MyJobsHeader.scss';

function MyJobsHeader(props) {
  const { showAppliedJobsText } = props;
  return (
    <div className="my_jobs_header">
      <div className="logo">
        <img src={MitraLogo} alt="logo" />
        <h4> Mitra</h4>
      </div>
      <div>
        {/* <span>{showAppliedJobsText ? 'Applied jobs' : ' '}</span> */}
        {navigator && navigator.userAgent && navigator.userAgent.includes('wv')
         && 
        <span><a className='header-logout-link'href='http://mitra.vahan.co/app-logout'>Logout?</a></span>
        }
      </div>
    </div>
  );
}

MyJobsHeader.propTypes = {
  showAppliedJobsText: PropTypes.bool,
};

MyJobsHeader.defaultProps = {
  showAppliedJobsText: true,
};

export default MyJobsHeader;
